import {Dropdown} from 'antd';
import React, {useEffect} from 'react';
import {CheckIcon, DownIcon} from './components/SvgIcons/SvgIcons';

const CustomSelect = ({
  handleFilterActive,
  handleGetChannels,
  handleFilterCompleted,
  filter,
  filterActive,
  filterCompleted,
}) => {
  return (
    <div className="custom-menu">
      <Dropdown
        overlay={
          <SelectList
            handleFilterActive={handleFilterActive}
            handleGetChannels={handleGetChannels}
            handleFilterCompleted={handleFilterCompleted}
            filter={filter}
            filterActive={filterActive}
            filterCompleted={filterCompleted}
          />
        }
        placement="bottomRight"
        trigger={['click']}>
        {filterActive ? (
          <button className="active-btn">
            Active
            <DownIcon />
          </button>
        ) : (
          <button className="active-btn">
            Completed
            <DownIcon />
          </button>
        )}
      </Dropdown>
    </div>
  );
};

export default CustomSelect;

export const SelectList = ({
  handleFilterActive,
  handleGetChannels,
  handleFilterCompleted,
  filter,
  filterActive,
  filterCompleted,
}) => {
  useEffect(() => {
    handleGetChannels();
  }, [filter]);

  return (
    <div className="select-list-wrapper">
      <div className="select-list-menu" onClick={() => handleFilterActive()}>
        {filterActive ? <CheckIcon /> : null} <p>Active</p>
      </div>
      <div className="select-list-menu" onClick={() => handleFilterCompleted()}>
        {filterCompleted ? <CheckIcon /> : null} <p>Completed</p>
      </div>
    </div>
  );
};
